/**
 *
 * SOUS-MENUS
 *
 */

const submenus = document.querySelectorAll('[data-submenu]');
const menuContainer = document.querySelector('#js-menu__container');

submenus &&
  submenus.forEach((submenu) => {
    const target = document.querySelector(
      '[data-id="' + submenu.dataset.submenu + '"]'
    );

    submenu &&
      submenu.addEventListener('click', (e) => {
        e.preventDefault();
        const currentActive = document.querySelector('.-has-visible-submenu');
        const currentVisible = document.querySelector('.submenu.-visible');

        if (submenu == currentActive) {
        }

        currentVisible && currentVisible.classList.remove('-visible');
        currentActive && currentActive.classList.remove('-has-visible-submenu');
        target && target.classList.add('-visible');
        submenu.classList.add('-has-visible-submenu');
      });
    // menuContainer &&
    //   menuContainer.addEventListener('mouseleave', () => {
    //     const currentVisible = document.querySelector('.submenu.-visible');
    //     const currentActive = document.querySelector('.-has-visible-submenu');
    //     currentVisible && currentVisible.classList.remove('-visible');
    //     currentActive && currentActive.classList.remove('-has-visible-submenu');
    //   });
  });

/**
 *
 * AUSHA PLAYER
 *
 */
jQuery(function ($) {
  $('.launch-ausha').on('click', function (e) {
    e.preventDefault();
    $('.podcast__ausha').show();
    var episodeUrl = $(this).attr('data-url');
    $('#ausha-player').attr(
      'src',
      'https://player.ausha.co/index.html?showId=B6vDeTGznqD7&color=171717&podcastId=' +
        episodeUrl +
        '&v=3&playerId=ausha-xzDg&display=horizontal'
    );
  });
});

/**
 *
 * SLIDERS PODCASTS PAR SAISON
 *
 */
jQuery(function ($) {
  $('.slider-podcast-saison').slick({
    dots: false,
    infinite: false,
    speed: 500,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 3,
    swipeToSlide: false, // set to true & improve drag but force slide 1 at a time
    centerMode: false,
    variableWidth: true,
    useTransform: false,
    nextArrow:
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32.635 32.635" width="26" height="32" data-role="none" class="slick-arrow slick-next"><path d="M32.135 16.817H.5a.5.5 0 0 1 0-1h31.635a.5.5 0 0 1 0 1z"></path><path d="M19.598 29.353a.5.5 0 0 1-.354-.853l12.184-12.184-12.184-12.18a.5.5 0 0 1 .707-.707l12.537 12.533a.5.5 0 0 1 0 .708L19.951 29.206a.495.495 0 0 1-.353.147z"></path></svg>',
    prevArrow:
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32.635 32.635" width="26" height="32" data-role="none" class="slick-arrow slick-prev"><path d="M32.135 16.817H.5a.5.5 0 0 1 0-1h31.635a.5.5 0 0 1 0 1z"></path><path d="M13.037 29.353a.502.502 0 0 1-.354-.146L.146 16.669a.504.504 0 0 1 0-.708L12.684 3.429a.5.5 0 0 1 .707.707L1.207 16.315l12.184 12.184a.5.5 0 0 1-.354.854z"></path></svg>',
    responsive: [
      {
        breakpoint: 1080,
        settings: {
          slidesToScroll: 2,
          speed: 300,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToScroll: 3,
          speed: 300,
        },
      },
      {
        breakpoint: 920,
        settings: {
          slidesToScroll: 2,
          speed: 300,
        },
      },
      {
        breakpoint: 670,
        settings: {
          slidesToScroll: 1,
          speed: 300,
        },
      },
    ],
  });
});

/**
 *
 * GUIDE TRAIN DE NUIT – SCROLL TO MAP
 *
 */
const tdnArrow = document.querySelector('#tdn_gotomap');
const tdnMap = document.querySelector('#tdn_map');

tdnArrow &&
  tdnMap &&
  tdnArrow.addEventListener('click', () => {
    tdnMap.scrollIntoView({
      behaviour: 'smooth',
    });
  });

const tdnMobileButton = document.querySelector('#gototdnform');
const tdn_form_1 = document.querySelector('#tdn_signup_1');
tdnMobileButton &&
  tdn_form_1 &&
  tdnMobileButton.addEventListener('click', function () {
    console.log('click');
    tdn_form_1.scrollIntoView({
      behaviour: 'smooth',
    });
  });

var isInViewport = function (elem) {
  var distance = elem.getBoundingClientRect();
  return (
    distance.top >= 0 &&
    distance.bottom >= 0 &&
    distance.bottom <=
      (window.innerHeight || document.documentElement.clientHeight)
  );
};

/**
 *
 *
 * Fix form if initial one out of view
 *
 */

const tdn_form = document.querySelector('#tdn_signup_1');
const tdn_form_2 = document.querySelector('#tdn_signup_2');
const tdn_fixed_form = document.querySelector('#tdn_fixed_form');

tdn_form && tdn_form_2;
tdn_fixed_form &&
  window.addEventListener(
    'scroll',
    function (event) {
      if (isInViewport(tdn_form) || isInViewport(tdn_form_2)) {
        tdn_fixed_form.classList.remove('-visible');
      } else {
        tdn_fixed_form.classList.add('-visible');
      }
    },
    false
  );

jQuery(function ($) {
  $('.trains_slideshow').slick({
    dots: false,
    infinite: false,
    speed: 500,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: true, // set to true & improve drag but force slide 1 at a time
    centerMode: false,
    variableWidth: false,
    nextArrow:
      '<svg class="slick-arrow slick-next" xmlns="http://www.w3.org/2000/svg" width="14.246" height="69.334" viewBox="0 0 14.246 69.334"><path id="Flèche" d="M1876.684,655.77l34.076,13.243,34.9-13.243" transform="translate(-655.302 1945.836) rotate(-90)" fill="none" stroke="#000" stroke-width="1"/></svg>',
    prevArrow:
      '<svg class="slick-arrow slick-prev" xmlns="http://www.w3.org/2000/svg" width="14.247" height="69.334" viewBox="0 0 14.247 69.334"><path id="Flèche" d="M1876.684,655.77l34.076,13.243,34.9-13.243" transform="translate(669.549 -1876.502) rotate(90)" fill="none" stroke="#000" stroke-width="1"/></svg>',
  });
  $('.slider-tdn-summary').slick({
    dots: true,
    infinite: false,
    speed: 300,
    arrows: false,
    slidesToShow: 1,
    centerMode: false,
    variableWidth: true,
    centerPadding: '0px',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          variableWidth: false,
          centerMode: true,
          slidesToShow: 1,
        },
      },
    ],
  });

  // let tdn_blocked = false;
  // let tdn_blockTimeout = null;
  // let tdn_prevDeltaY = 0;
  // $('.slider-tdn-summary').on('mousewheel DOMMouseScroll wheel', function (e) {
  //   let deltaY = e.originalEvent.deltaY;
  //   e.preventDefault();
  //   e.stopPropagation();

  //   clearTimeout(tdn_blockTimeout);
  //   tdn_blockTimeout = setTimeout(function () {
  //     tdn_blocked = false;
  //   }, 50);

  //   if (
  //     (deltaY > 0 && deltaY > tdn_prevDeltaY) ||
  //     (deltaY < 0 && deltaY < tdn_prevDeltaY) ||
  //     !tdn_blocked
  //   ) {
  //     tdn_blocked = true;
  //     tdn_prevDeltaY = deltaY;

  //     if (deltaY > 0) {
  //       $(this).slick('slickNext');
  //     } else {
  //       $(this).slick('slickPrev');
  //     }
  //   }
  // });

  let tdn_blocked = false;
  let tdn_blockTimeout = null;
  let tdn_prevDeltaX = 0;

  $('.slider-tdn-summary').on('mousewheel DOMMouseScroll wheel', function (e) {
    let deltaX = e.originalEvent.deltaX;
    let deltaY = e.originalEvent.deltaY;

    if (typeof deltaY != 'undefined') {
      clearTimeout(tdn_blockTimeout);
      tdn_blockTimeout = setTimeout(function () {
        tdn_blocked = false;
      }, 50);

      if (
        deltaY < 1 &&
        deltaY > -1 &&
        ((deltaX > 10 && deltaX > tdn_prevDeltaX) ||
          (deltaX < -10 && deltaX < tdn_prevDeltaX) ||
          !tdn_blocked)
      ) {
        e.preventDefault();
        e.stopPropagation();

        tdn_blocked = true;
        tdn_prevDeltaX = deltaX;

        if (deltaX > 0) {
          $(this).slick('slickNext');
        } else {
          $(this).slick('slickPrev');
        }
      }
    }
  });
});
